import useBlobStorage from "hooks/useBlobStorage.ts";
import { useEffect, useMemo, useState } from "react";
import DOMPurify from "dompurify";

const useSupportQuestions = () => {
	const { getContainerBlob } = useBlobStorage();
	const [html, setHtml] = useState("");
	const [isLoading, setIsLoading] = useState(true);
	const [isError, setIsError] = useState(false);

	useEffect(() => {
		const controller = new AbortController();

		const loadQuestions = async () => {
			setIsLoading(true);
			setIsError(false);

			try {
				const url = await getContainerBlob("support-container", "Tandem-Questions.html");

				if (controller.signal.aborted) return;

				const response = await fetch(url, {
					signal: controller.signal
				});

				if (!response.ok) {
					throw new Error("Unable to load support questions.");
				}

				const content = await response.text();

				if (!controller.signal.aborted) {
					setHtml(content);
				}
			} catch {
				if (!controller.signal.aborted) {
					setIsError(true);
				}
			} finally {
				if (!controller.signal.aborted) {
					setIsLoading(false);
				}
			}
		};

		void loadQuestions();

		return () => controller.abort();
	}, [getContainerBlob]);

	const questions = useMemo(() => {
		const sanitizedHtml = DOMPurify.sanitize(html);
		const document = new DOMParser().parseFromString(sanitizedHtml, "text/html");

		return Array.from(document.body.querySelectorAll(":scope > div")).flatMap((section, index) => {
			const heading = section.querySelector(":scope > p");
			const title = heading?.textContent?.trim();

			if (!heading || !title) return [];

			heading.remove();

			return [
				{
					id: `support-question-${index + 1}`,
					title,
					answerHtml: section.innerHTML.trim()
				}
			];
		});
	}, [html]);
	return { questions, isLoading, isError };
};

export default useSupportQuestions;
